@if(mode==="edit" || mode==="add"){
<div pplFocusTrap>
  <div class="ppl-mt20">
    <form nz-form nz-row [formGroup]="enrollmentStatus" class="ppl-p0">
      @if(isAttrAvailable('status')){
      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="status" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'status']">{{ getAttributes("status").label }}
            @if(getAttributes('status').mandatory === 'Y'){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('status').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['status'] }">
              <ppl-dropdown-select formControlName="status" id="status" placeholder="Select Enrollment Status"
                [disabled]="mode === 'edit'" [options]="allowedStatus" [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['status']) {
            <span class="pl-1 error-message">{{validationErrors['status']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }

      <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left"></div>


      @if(isAttrAvailable('startDate') && !disableStatus){
      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="startDate"
            class="ppl-form-label">{{getAttributes('startDate').label}}
            @if(getAttributes('startDate').mandatory === 'Y' || isDisenrollSelected){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''" nzTooltipPlacement="topRight">
              <!-- <nz-date-picker formControlName="startDate" [id]="'startDate'" style="height: 32px;"
              [nzDisabledDate]="disabledStartDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('startDate').placeholder"
              [ngClass]="{'error': validationErrors['startDate'] }"></nz-date-picker> -->
              <ppl-date-picker formControlName="startDate" [id]="'startDate'" [showIcon]="true"
                [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                [iconDisplay]="'input'" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
                [minDate]="restoreMinStartDate ?? disenrollMinStartDate" [maxDate]="restoreMaxStartDate ?? minStartDate" [styleClass]="validationErrors['startDate'] ? 'error' : ''">
              </ppl-date-picker>
            </div>
            @if (validationErrors['startDate']) {
            <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }

      @if(isAttrAvailable('endDate') && !disableStatus){
      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

        <nz-row>

          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="endDate"
            class="ppl-form-label">{{getAttributes('endDate').label}}
            @if((getAttributes('endDate').mandatory === 'Y' || isEndDateMandatory) && !isDisenrollSelected){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''" nzTooltipPlacement="topRight">
              <!-- <nz-date-picker formControlName="endDate" [id]="'endDate'" style="height: 32px;" [nzFormat]="'MM/dd/yyyy'"
              [nzDisabledDate]="disabledEndDate" [nzPlaceHolder]="getAttributes('endDate').placeholder"
              [ngClass]="{'error': validationErrors['endDate'] }"></nz-date-picker> -->
              <ppl-date-picker formControlName="endDate" [id]="'endDate'" [showIcon]="true"
                [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                [iconDisplay]="'input'" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
                [minDate]="maxEndDate" [disabled]="isDisenrollSelected" [styleClass]="(validationErrors['endDate'] && !isDisenrollSelected) ? 'error' : ''">
              </ppl-date-picker>
            </div>
            @if (validationErrors['endDate'] && !isDisenrollSelected) {
            <span class="pl-1 error-message">{{validationErrors['endDate']}}</span>
            }
            @if(isEndDateMandatory && !isDisenrollSelected && enrollmentStatus.get('endDate')?.touched && !enrollmentStatus.get('endDate')?.value){
            <span class="pl-1 error-message">Please select End Date.</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }

      @if(isAttrAvailable('reason')){
      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="reason" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'reason']">{{ getAttributes("reason").label }}
            @if(getAttributes('reason').mandatory === 'Y'){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('reason').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['reason'] }">
              <ppl-dropdown-select formControlName="reason" id="reason" placeholder="Select Reason"
                [options]="isDisenrollSelected ? disenrollReasonList : statusReasons" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['reason']) {
            <span class="pl-1 error-message">{{validationErrors['reason']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }

      @if(isAttrAvailable('comment')){
      <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item  nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="comment"
            class="ppl-form-label">{{getAttributes('comment').label}}
            @if(getAttributes('comment').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('comment').tooltip}}"
            nzTooltipPlacement="topRight">
            <textarea rows="4" cols="40" nz-input formControlName="comment" nzId="comment" class="ppl-form-control"
              placeholder="{{getAttributes('comment').placeholder}}"
              [ngClass]="{'error': validationErrors['comment'] }"></textarea>
            @if (validationErrors['comment']) {
            <span class="pl-1 error-message">{{validationErrors['comment']}}</span>
            }
          </nz-form-control>

        </nz-row>

      </nz-form-item>
      }
    </form>
  </div>
  @if(showStatusAddErrorMessage) {
  <div class="w-100 alert alert-danger custom-message">{{customErrorMessage}}</div>
  }
  <div class="custom-row">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="cancelEdit()"></ppl-button>
    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="save()" *authorize="[pageId, tabId, 'EligibilityDates', 'section', 'edit']"></ppl-button>
  </div>
</div>
} @else if(mode==="read"){
@if (!disableAddStatus && !readonly) {
<div class="custom-row">
  <div class="mr-2">
    <ppl-button label="Add Status" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="add()" *authorize="[pageId, tabId, 'EligibilityDates', 'section', 'edit']"></ppl-button>
  </div>
</div>
}

@if (showMoveToInPPLReviewButton && !readonly) {
<div class="custom-row">
  <div class="mr-2">
    <ppl-button label="Move to PPL Review" icon="fa fa-arrow-circle-right" [customClass]="'ghost-button'"
      [iconPosition]="'left'" (click)="moveToPPLReview()"
      *authorize="[pageId, tabId, 'MoveToInPPLReview', 'section', 'edit']"></ppl-button>
  </div>
</div>
}

@if(copyOfGridData.length > 0){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [actionButtons]="actionButtons">
</ppl-list-table>
}@else {
<nz-row>
  <p>No Data found</p>
</nz-row>
}



}@else if (mode==="read" && !copyOfGridData) {
<nz-row>
  <p>No Data found</p>
</nz-row>
}
